import '../assets/NcAppNavigation-wkQJnaLW.css';
import { useIsMobile as n } from "../Composables/useIsMobile.mjs";
import { g as s } from "./focusTrap-Be9GEB5C.mjs";
import { subscribe as p, emit as o, unsubscribe as r } from "@nextcloud/event-bus";
import { createFocusTrap as l } from "focus-trap";
import { N as g } from "./NcAppNavigationToggle-D0oeWL17.mjs";
import c from "../Components/NcAppNavigationList.mjs";
import u from "vue";
import { n as d } from "./_plugin-vue2_normalizer-Bj5bLKV4.mjs";
const v = {
  name: "NcAppNavigation",
  components: {
    NcAppNavigationList: c,
    NcAppNavigationToggle: g
  },
  // Injected from NcContent
  inject: {
    setHasAppNavigation: {
      default: () => () => u.util.warn("NcAppNavigation is not mounted inside NcContent, this is probably an error."),
      from: "NcContent:setHasAppNavigation"
    }
  },
  props: {
    /**
     * The aria label to describe the navigation
     */
    ariaLabel: {
      type: String,
      default: ""
    },
    /**
     * aria-labelledby attribute to describe the navigation
     */
    ariaLabelledby: {
      type: String,
      default: ""
    }
  },
  setup() {
    return {
      isMobile: n()
    };
  },
  data() {
    return {
      open: !this.isMobile,
      focusTrap: null
    };
  },
  watch: {
    isMobile() {
      this.open = !this.isMobile, this.toggleFocusTrap();
    },
    open() {
      this.toggleFocusTrap();
    }
  },
  mounted() {
    this.setHasAppNavigation(!0), p("toggle-navigation", this.toggleNavigationByEventBus), o("navigation-toggled", {
      open: this.open
    }), this.focusTrap = l(this.$refs.appNavigationContainer, {
      allowOutsideClick: !0,
      fallbackFocus: this.$refs.appNavigationContainer,
      trapStack: s(),
      escapeDeactivates: !1
    }), this.toggleFocusTrap();
  },
  unmounted() {
    this.setHasAppNavigation(!1), r("toggle-navigation", this.toggleNavigationByEventBus), this.focusTrap.deactivate();
  },
  methods: {
    /**
     * Toggle the navigation
     *
     * @param {boolean} [state] set the state instead of inverting the current one
     */
    toggleNavigation(i) {
      if (this.open === i) {
        o("navigation-toggled", {
          open: this.open
        });
        return;
      }
      this.open = typeof i > "u" ? !this.open : i;
      const t = getComputedStyle(document.body), a = parseInt(t.getPropertyValue("--animation-quick")) || 100;
      setTimeout(() => {
        o("navigation-toggled", {
          open: this.open
        });
      }, 1.5 * a);
    },
    toggleNavigationByEventBus({ open: i }) {
      this.toggleNavigation(i);
    },
    /**
     * Activate focus trap if it is currently needed, otherwise deactivate
     */
    toggleFocusTrap() {
      this.isMobile && this.open ? this.focusTrap.activate() : this.focusTrap.deactivate();
    },
    handleEsc() {
      this.isMobile && this.toggleNavigation(!1);
    }
  }
};
var f = function() {
  var t = this, a = t._self._c;
  return a("div", { ref: "appNavigationContainer", staticClass: "app-navigation", class: { "app-navigation--close": !t.open } }, [a("nav", { staticClass: "app-navigation__content", attrs: { id: "app-navigation-vue", "aria-hidden": t.open ? "false" : "true", "aria-label": t.ariaLabel || void 0, "aria-labelledby": t.ariaLabelledby || void 0, inert: !t.open || void 0 }, on: { keydown: function(e) {
    return !e.type.indexOf("key") && t._k(e.keyCode, "esc", 27, e.key, ["Esc", "Escape"]) ? null : t.handleEsc.apply(null, arguments);
  } } }, [a("div", { staticClass: "app-navigation__body", class: { "app-navigation__body--no-list": !t.$scopedSlots.list } }, [t._t("default")], 2), t.$scopedSlots.list ? a("NcAppNavigationList", { staticClass: "app-navigation__list" }, [t._t("list")], 2) : t._e(), t._t("footer")], 2), a("NcAppNavigationToggle", { attrs: { open: t.open }, on: { "update:open": t.toggleNavigation } })], 1);
}, h = [], m = /* @__PURE__ */ d(
  v,
  f,
  h,
  !1,
  null,
  "42389274",
  null,
  null
);
const S = m.exports;
export {
  S as N
};
